import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import BookCta from "@/components/BookCta";

export default function FAQs() {
  useSeo({ title: "FAQs — Face Painting in Nanaimo", description: "Answers to common questions about booking, service areas, safety, and what to expect from Paint With Tay." });
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="faqs-page">
      <section className="section py-14 max-w-3xl">
        <Reveal>
          <div className="text-center mb-8">
            <div className="w-14 h-14 mx-auto rounded-full bg-brightblue border-[3px] border-ink flex items-center justify-center mb-3">
              <HelpCircle className="w-7 h-7 text-ink" />
            </div>
            <p className="font-accent text-3xl text-hotpink">Good to know</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-700">Frequently Asked Questions</h1>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((f) => (
              <AccordionItem key={f.id} value={f.id} className="card-soft px-5 border-b-[3px]">
                <AccordionTrigger className="font-heading text-lg text-left hover:no-underline py-4">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-ink/80 font-body text-base pb-5">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <p className="text-center mt-8 text-ink/70">
          Still have a question?{" "}
          <Link to="/contact" className="text-hotpink font-700 underline">Get in touch with Tay</Link>.
        </p>
      </section>
      <BookCta />
    </div>
  );
}
